<template>
  <div class="home">
    <router-link
      :to="{
        name: 'Team-Collection-Home',
        params: { team_slug: team.slug, collection_slug: collection_slug },
      }"
      v-if="team"
    >
      <div v-if="collection" class="text-center p-2 bg-gray-300">
        {{ collection.name }}
      </div>
    </router-link>
    <router-view v-if="!loading" />
  </div>
</template>

<script>
import store from "@/store";
import { onMounted, ref, computed, onUnmounted } from "vue";

import Navigation from "@/components/Navigation.vue";
import router from "@/router";

export default {
  name: "Team-Collection",
  components: {
    Navigation,
  },
  props: {
    collection_slug: String,
  },
  setup(props) {
    const team = computed(() => {
      return store.state.team.item;
    });
    const collection = computed(() => {
      return store.state.team.collection;
    });
    const loading = ref(true);

    onMounted(() => {
      store.dispatch("loading/setGlobal", true);
      store
        .dispatch("team/getCollection", props.collection_slug)
        .then((data) => {
          loading.value = false;
        })
        .catch((e) => {
          console.log(e);
          store.dispatch("toasts/error", "Could not load collection");
          // router.push({ name: "Home" });
        })
        .finally(() => {
          store.dispatch("loading/setGlobal", false);
        });
    });

    onUnmounted(() => {});

    return { collection, loading, team };
  },
};
</script>
